import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Admin console banner: new purchase count, with a pop-up when a purchase arrives while the page is open.
export const AdminAlertBanner = () => {
  const [unread, setUnread] = useState(0);
  const seen = useRef(null);
  useEffect(() => {
    const load = () => api.get("/admin/alerts").then(({ data }) => {
      setUnread(data.unread);
      const latest = data.items[0];
      if (seen.current !== null && latest && latest.id !== seen.current && !latest.read) toast.success(`New purchase: ${latest.buyer_name} bought ${latest.courses.join(", ")}`);
      seen.current = latest ? latest.id : "";
    }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  return (
    <Link to="/admin/analytics" data-testid="admin-alert-banner"
      className={`mt-4 flex items-center justify-between gap-3 rounded-2xl border p-4 transition-colors ${unread ? "border-primary bg-primary/10" : "border-border bg-card hover:border-primary"}`}>
      <span className="flex items-center gap-2 text-sm font-semibold"><Bell size={16} className="text-primary" />
        {unread ? <span data-testid="admin-alert-count">{unread} new course purchase{unread === 1 ? "" : "s"}</span> : "Visitors & purchase alerts"}
      </span>
      <span className="text-sm font-semibold text-primary">Visitors, platforms &amp; purchases →</span>
    </Link>
  );
};
